<script>
import axios from "axios";

import i18n from "../i18n";

import { breadcrumbs } from "./breadcrumb";
// import auth from "../../../server/api/auth";
import auth from "@/server/api/auth";
import mediaApi from "@/server/api/media";
import { PERMISSIONS } from "@/router/views/account/roles/menuAttrs";
import { uniqWith } from "lodash";
import { EventBus } from "@/util/eventBus.js";
// import simplebar from "simplebar-vue";

/**
 * Nav-bar Component
 */
export default {
  inject: ["reload"],
  data() {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/french.jpg"),
          language: "fr",
          title: "French",
        },
        {
          flag: require("@/assets/images/flags/spain.jpg"),
          language: "es",
          title: "Spanish",
        },
        {
          flag: require("@/assets/images/flags/chaina.png"),
          language: "zh",
          title: "Chinese",
        },
        {
          flag: require("@/assets/images/flags/arabic.png"),
          language: "ar",
          title: "Arabic",
        },
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,
      userName: "",
      avatar: "",
      appBreadcrumbs: breadcrumbs,
      breadcrumb: [],
      actOptions: [],
      dialogVisible: false,
      usToken: "",
      chosedAccount: {},
      groups: PERMISSIONS,
      adminId: undefined,
      uploadList: [],
      //上传提示弹窗
      showAlert: false,
      uploadState: "light",
      uploadTitle: "文件上传中",
      showExpand: false,
      timer: 10000,
      timer1: 1000,
      uploadStart: false,
      uploadEnd: false,
      uploadTotal: 1,
      uploadedNum: 0,
    };
  },
  // components: { simplebar },
  beforeDestroy() {
    EventBus.$off("mediaLibrary");
  },
  mounted() {
    EventBus.$off("mediaLibrary");
    EventBus.$on("mediaLibrary", (data) => {
      clearTimeout(this.timer1);
      console.log("收到了消息", this.another(data));
      this.uploadList.push(data);
      this.uploadTitle = "文件上传中";
      if (!this.showAlert) {
        this.showAlert = true;
      }
      if (!this.uploadStart) {
        this.uploadStart = true;
        this.uploadEnd = false;
        this.timer = setInterval(this.showUpload, 500);
      }
    });
    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
    if (!localStorage.chosedMedia || !localStorage.mediaList) {
      return;
    }
    let user = JSON.parse(localStorage.chosedMedia);
    // let user = JSON.parse(this.cookies.getCookie("user"));
    // let userList = JSON.parse(this.cookies.getCookie("userList"));
    let userList = JSON.parse(localStorage.mediaList);
    this.actOptions = userList;
    // console.log(userList);
    this.actOptions.forEach((v) => {
      if (v.name == user.name) {
        v.checked = true;
      }
    });
    this.userName = user.name;
    this.avatar = user.avatar;
    this.getBreadcrumb();
    this.adminId = JSON.parse(this.cookies.getCookie("user")).id;
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },

  methods: {
    getBreadcrumb() {
      let appPath = this.$route.fullPath;
      let breadcrumb = [];
      for (var i = 0; i < this.appBreadcrumbs.length; i++) {
        let item = this.appBreadcrumbs[i];
        if (appPath.indexOf(item.link) != -1) {
          breadcrumb = item.breadcrumb;
          break;
        }
      }
      this.breadcrumb = breadcrumb;
      console.log("路由跳转", this.breadcrumb);
    },

    toLink(item) {
      if (item.path) {
        if (item.goBack) {
          //path和goback同时存在时优先使用goBack
          let num = Number(item.goBack);
          if (window.history.length > num) {
            //如果有历史记录就返回，不能返回才使用path
            this.$router.go(-num);
            return;
          }
        }
        if (this.$route.fullPath != item.path) {
          let path = item.path.split("?type=");
          if (path[1]) {
            this.$router.push({
              name: path[0],
              query: { type: path[1] },
            });
            if (this.breadcrumb[1].path == item.path) {
              this.reload();
            }
          } else {
            this.$router.push({
              name: path[0],
            });
          }
        }
      }
    },

    toggleMenu() {
      this.$parent.toggleMenu();
    },

    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },

    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
    },
    // logoutUser() {
    //   // eslint-disable-next-line no-unused-vars
    //   axios.get("http://127.0.0.1:8000/api/logout").then((res) => {
    //     this.$router.push({
    //       name: "default",
    //     });
    //   });
    // },
    getRelationMedia() {
      // console.log("获取最新媒体号列表");
      auth
        .getRelationMedia({
          adminId: this.adminId,
        })
        .then((res) => {
          // console.log("关联媒体号列表", res);
          if (res.code === 0) {
            // this.accountList = res.data;
            this.cookies.setCookie("userList", JSON.stringify(res.data));
            localStorage.mediaList = JSON.stringify(res.data);
            this.actOptions = res.data;
            // console.log(userList);
            let user = JSON.parse(localStorage.chosedMedia);
            this.actOptions.forEach((v) => {
              if (v.id == user.id) {
                v.checked = true;
                this.userName = v.name;
                this.avatar = v.avatar;
                localStorage.chosedMedia = JSON.stringify(v);
              }
            });
          }
        });
    },
    logout() {
      this.cookies.clearCookie("token");
      this.cookies.clearCookie("user");
      localStorage.removeItem("power");
      localStorage.removeItem("chosedMedia");
      localStorage.removeItem("mediaList");
      // this.cookies.clearCookie("powerMenuAttrs");
      this.$router.push({
        name: "login",
      });
    },
    cutAccount(item) {
      if (item.checked) {
        // this.info("请选择其它账号");
        return;
      }
      this.chosedAccount = item;
      console.log("选择的账号", this.chosedAccount);
      // console.log(item);
      // this.usToken = item.token;
      // this.actOptions = this.$options.data().actOptions;
      // console.log((item.checked = true));
      this.dialogVisible = true;
    },
    async handleOk() {
      let check = false;
      await auth
        .checkAccount({ mediaId: this.chosedAccount.id })
        .then((res) => {
          if (res.code === 0) {
            if (res.data.state == 1) {
              check = true;
            } else {
              check = false;
            }
          }
        });
      if (!check) {
        this.warning("您在该媒体号下的账号已被冻结");
        return;
      }
      mediaApi.detail({ id: this.chosedAccount.id }).then((res) => {
        console.log("媒体号详情", res);
        if (res.code === 0) {
          localStorage.chosedMedia = JSON.stringify(res.data);
          this.getPowerInfo();
          // if (res.data.state === 1) {
          //   // this.cookies.setCookie(
          //   //   "chosedMedia",
          //   //   JSON.stringify(this.checkAccount)
          //   // );

          // } else {
          //   this.warning("媒体号状态异常,请更换媒体号");
          // }
        } else {
          this.warning("媒体号状态校验失败，请稍候重试");
        }
      });
      // this.cookies.setCookie("token", this.usToken);
      // sessionStorage.removeItem("examineParams");
      // // console.log(this.usToken);
      // let params = {
      //   userType: 1,
      // };
      // auth.userInfo(params).then((resp) => {
      //   if (resp.data) {
      //     // console.log(resp.data);
      //     this.cookies.setCookie("user", JSON.stringify(resp.data));
      //     location.reload();
      //     // this.$router.push({
      //     //   name: "dashboard",
      //     // });
      //   }
      // });
    },
    getPowerInfo() {
      let params = { mediaId: this.chosedAccount.id };
      auth.power(params).then((resp) => {
        console.log("获取权限的参数", params);
        console.log("权限数据", resp);
        if (resp.code === 0) {
          this.$router.push({
            name: "dashboard",
          });
          // if (resp.data) {
          //   localStorage.setItem(
          //     "powerMenuAttrs",
          //     JSON.stringify(resp.data.menuAttrs)
          //   );
          // }
          if (resp.data && resp.data.menuAttrs) {
            this.setMenuAttrs(resp.data.menuAttrs);
          } else {
            this.setMenuAttrs([]);
          }
          location.reload();
        } else {
          this.warning("权限数据获取失败，请稍候重试");
        }
      });
    },
    setMenuAttrs(items) {
      console.log(items);
      let groupsList = JSON.parse(JSON.stringify(this.groups));
      for (var i = 0; i < items.length; i++) {
        let key = items[i].key;
        for (let k in groupsList) {
          for (var f = 0; f < groupsList[k].length; f++) {
            let f_item = groupsList[k][f];
            if (key === f_item.key) {
              f_item.exists = true;
            }
          }
        }
      }
      localStorage.setItem("power", JSON.stringify(groupsList));
      // this.$router.push({
      //   name: "dashboard"
      // });
      // console.log(groupsList)
    },
    //上传提示弹窗
    closeAlert() {
      this.showAlert = false;
      clearInterval(this.timer);
      this.uploadEnd = false;
      this.uploadStart = false;
      let arr = this.uploadList;
      for (let a = 0; a < arr.length; a++) {
        if (arr[a].status == "success" || arr[a].status == "error") {
          arr.splice(a, 1);
          a--;
        }
      }
    },
    show_expand(judge) {
      if (judge) {
        this.showExpand = true;
      } else {
        this.showExpand = false;
      }
    },
    showUpload() {
      let result = true;
      let tem = 0;
      this.uploadTotal = this.uploadList.length;
      let num = 0;
      let errorNum = 0;
      this.uploadList.forEach((item) => {
        // if (item.rate < 100) {
        result = false;
        tem = sessionStorage[item.sessionName]
          ? sessionStorage[item.sessionName]
          : tem;
        if (tem === "00") {
          errorNum++;
          item.status = "error";
          return;
        } else if (tem === "000") {
          ++num;
          item.status = "success";
          item.rate = 100;
          item.loaded = item.size;
        } else {
          item.rate = Number(tem);
          item.loaded = ((item.size * item.rate) / 100).toFixed(1);
        }
        // } else {
        //   // item.status = "success";
        //   item.loaded = item.size;
        //   num++;
        // }
      });
      this.uploadedNum = num;
      if (num === this.uploadTotal) {
        EventBus.$emit("mediaLibrary-refresh", "refresh");
        this.uploadTitle = "文件上传完成";
        this.timer1 = setTimeout(() => {
          this.closeAlert();
        }, 30000);
        // console.log("清除定时器");
        // console.log(this.uploadList);
        this.uploadEnd = true;
        clearInterval(this.timer);
        // this.success("文件上传完成！");
        this.uploadStart = false;
      } else if (errorNum + num == this.uploadTotal) {
        this.uploadStart = false;
        this.uploadEnd = true;
        if (errorNum == this.uploadTotal) {
          this.uploadTitle = "文件上传失败";
          // this.info("文件上传失败", "error");
        } else {
          this.uploadTitle = "部分文件上传失败";
          // this.info("部分文件上传失败", "error");
          EventBus.$emit("mediaLibrary-refresh", "refresh");
        }
        clearInterval(this.timer);
      }
    },
    showName(name) {
      let format = "." + name.split(".").splice(-1, 1)[0];
      let _name = name.replace(format, "");
      if (_name.length > 10) {
        return _name.substr(0, 7) + "..." + _name.substr(-3) + format;
      } else {
        return _name + format;
      }
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link tag="a" to="/" class="logo logo-dark">
            <span class="logo-sm">
              <!-- <img src="@/assets/images/logo.svg" alt height="22" /> -->
            </span>
            <span class="logo-lg app-name">
              媒体号管理后台
              <!-- <img src="@/assets/images/logo-dark.png" alt height="17" /> -->
            </span>
          </router-link>

          <router-link tag="a" to="/" class="logo logo-light">
            <span class="logo-sm">
              <!-- <img src="@/assets/images/logo_home@3x.png" alt height="30" /> -->
            </span>
            <span class="logo-lg app-name">
              <!-- <img src="@/assets/images/logo-light.png" alt height="35" /> -->
              媒体号管理后台
            </span>
          </router-link>
        </div>

        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <div class="app-breadcrumb">
          <el-breadcrumb>
            <el-breadcrumb-item
              v-for="(item, index) in breadcrumb"
              v-bind:key="index"
              :class="{ 'last-breadcrumb': index === breadcrumb.length - 1 }"
            >
              <span @click="toLink(item)">{{ item.title }}</span>
            </el-breadcrumb-item>
            <!-- <el-breadcrumb-item>活动列表</el-breadcrumb-item>
            <el-breadcrumb-item class="last-breadcrumb">活动详情</el-breadcrumb-item> -->
          </el-breadcrumb>
        </div>

        <!-- App Search-->
        <!-- 表头的搜索 -->
        <!-- <form class="app-search d-none d-lg-block">
          <div class="position-relative">
            <input
              type="text"
              class="form-control"
              :placeholder="$t('navbar.search.text')"
            />
            <span class="bx bx-search-alt"></span>
          </div>
        </form> -->

        <!-- 下拉快速路由地图指向 -->
        <!-- <b-dropdown
          variant="black"
          class="dropdown-mega d-none d-lg-block ms-2"
          toggle-class="header-item"
          menu-class="dropdown-megamenu"
        >
          <template v-slot:button-content>
            {{ $t("navbar.dropdown.megamenu.text") }}
            <i class="mdi mdi-chevron-down"></i>
          </template>

          <div class="row">
            <div class="col-sm-8">
              <div class="row">
                <div class="col-md-4">
                  <h5 class="font-size-14 mt-0">
                    {{ $t("navbar.dropdown.megamenu.uicontent.title") }}
                  </h5>
                  <ul class="list-unstyled megamenu-list">
                    <li>
                      <a href="javascript:void(0);">{{
                        $t("navbar.dropdown.megamenu.uicontent.list.lightbox")
                      }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{
                        $t(
                          "navbar.dropdown.megamenu.uicontent.list.rangeslider"
                        )
                      }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{
                        $t("navbar.dropdown.megamenu.uicontent.list.sweetalert")
                      }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{
                        $t("navbar.dropdown.megamenu.uicontent.list.rating")
                      }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{
                        $t("navbar.dropdown.megamenu.uicontent.list.forms")
                      }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{
                        $t("navbar.dropdown.megamenu.uicontent.list.tables")
                      }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{
                        $t("navbar.dropdown.megamenu.uicontent.list.charts")
                      }}</a>
                    </li>
                  </ul>
                </div>

                <div class="col-md-4">
                  <h5 class="font-size-14 mt-0">
                    {{ $t("navbar.dropdown.megamenu.application.title") }}
                  </h5>
                  <ul class="list-unstyled megamenu-list">
                    <li>
                      <a href="javascript:void(0);">{{
                        $t(
                          "navbar.dropdown.megamenu.application.list.ecommerce"
                        )
                      }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{
                        $t("navbar.dropdown.megamenu.application.list.calendar")
                      }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{
                        $t("navbar.dropdown.megamenu.application.list.email")
                      }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{
                        $t("navbar.dropdown.megamenu.application.list.projects")
                      }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{
                        $t("navbar.dropdown.megamenu.application.list.tasks")
                      }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{
                        $t("navbar.dropdown.megamenu.application.list.contacts")
                      }}</a>
                    </li>
                  </ul>
                </div>

                <div class="col-md-4">
                  <h5 class="font-size-14 mt-0">
                    {{ $t("navbar.dropdown.megamenu.extrapages.title") }}
                  </h5>
                  <ul class="list-unstyled megamenu-list">
                    <li>
                      <a href="javascript:void(0);">{{
                        $t(
                          "navbar.dropdown.megamenu.extrapages.list.lightsidebar"
                        )
                      }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{
                        $t(
                          "navbar.dropdown.megamenu.extrapages.list.compactsidebar"
                        )
                      }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{
                        $t(
                          "navbar.dropdown.megamenu.extrapages.list.horizontallayout"
                        )
                      }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{
                        $t(
                          "navbar.dropdown.megamenu.extrapages.list.maintenance"
                        )
                      }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{
                        $t(
                          "navbar.dropdown.megamenu.extrapages.list.comingsoon"
                        )
                      }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{
                        $t("navbar.dropdown.megamenu.extrapages.list.timeline")
                      }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{
                        $t("navbar.dropdown.megamenu.extrapages.list.faqs")
                      }}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="row">
                <div class="col-sm-6">
                  <h5 class="font-size-14 mt-0">
                    {{ $t("navbar.dropdown.megamenu.uicontent.title") }}
                  </h5>
                  <ul class="list-unstyled megamenu-list">
                    <li>
                      <a href="javascript:void(0);">{{
                        $t("navbar.dropdown.megamenu.uicontent.list.lightbox")
                      }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{
                        $t(
                          "navbar.dropdown.megamenu.uicontent.list.rangeslider"
                        )
                      }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{
                        $t("navbar.dropdown.megamenu.uicontent.list.sweetalert")
                      }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{
                        $t("navbar.dropdown.megamenu.uicontent.list.rating")
                      }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{
                        $t("navbar.dropdown.megamenu.uicontent.list.forms")
                      }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{
                        $t("navbar.dropdown.megamenu.uicontent.list.tables")
                      }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0);">{{
                        $t("navbar.dropdown.megamenu.uicontent.list.charts")
                      }}</a>
                    </li>
                  </ul>
                </div>

                <div class="col-sm-5">
                  <div>
                    <img
                      src="@/assets/images/megamenu-img.png"
                      alt
                      class="img-fluid mx-auto d-block"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-dropdown> -->
      </div>

      <div class="d-flex">
        <!-- <b-dropdown
          class="d-inline-block d-lg-none ms-2"
          variant="black"
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          right
        >
          <template v-slot:button-content>
            <i class="mdi mdi-magnify"></i>
          </template>

          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search ..."
                  aria-label="Recipient's username"
                />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </b-dropdown> -->

        <!-- 多语言切换 -->
        <!-- <b-dropdown variant="white" right toggle-class="header-item">
          <template v-slot:button-content>
            <img class :src="flag" alt="Header Language" height="16" />
            {{ text }}
          </template>
          <b-dropdown-item
            class="notify-item"
            v-for="(entry, i) in languages"
            :key="`Lang${i}`"
            :value="entry"
            @click="setLanguage(entry.language, entry.title, entry.flag)"
            :class="{ active: lan === entry.language }"
          >
            <img
              :src="`${entry.flag}`"
              alt="user-image"
              class="me-1"
              height="12"
            />
            <span class="align-middle">{{ entry.title }}</span>
          </b-dropdown-item>
        </b-dropdown> -->

        <!-- 功能模块 -->
        <!-- <b-dropdown
          class="d-none d-lg-inline-block noti-icon"
          menu-class="dropdown-menu-lg dropdown-menu-end"
          right
          toggle-class="header-item"
          variant="black"
        >
          <template v-slot:button-content>
            <i class="bx bx-customize"></i>
          </template>

          <div class="px-lg-2">
            <div class="row no-gutters">
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="@/assets/images/brands/github.png" alt="Github" />
                  <span>{{ $t("navbar.dropdown.site.list.github") }}</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img
                    src="@/assets/images/brands/bitbucket.png"
                    alt="bitbucket"
                  />
                  <span>{{ $t("navbar.dropdown.site.list.github") }}</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img
                    src="@/assets/images/brands/dribbble.png"
                    alt="dribbble"
                  />
                  <span>{{ $t("navbar.dropdown.site.list.dribbble") }}</span>
                </a>
              </div>
            </div>

            <div class="row no-gutters">
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="@/assets/images/brands/dropbox.png" alt="dropbox" />
                  <span>{{ $t("navbar.dropdown.site.list.dropbox") }}</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img
                    src="@/assets/images/brands/mail_chimp.png"
                    alt="mail_chimp"
                  />
                  <span>{{ $t("navbar.dropdown.site.list.mailchimp") }}</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="@/assets/images/brands/slack.png" alt="slack" />
                  <span>{{ $t("navbar.dropdown.site.list.slack") }}</span>
                </a>
              </div>
            </div>
          </div>
        </b-dropdown> -->

        <!-- 全屏显示 -->
        <!-- <div class="dropdown d-none d-lg-inline-block ms-1">
          <button
            type="button"
            class="btn header-item noti-icon"
            @click="initFullScreen"
          >
            <i class="bx bx-fullscreen"></i>
          </button>
        </div> -->

        <!-- <b-dropdown
          right
          menu-class="dropdown-menu-lg p-0 dropdown-menu-end"
          toggle-class="header-item noti-icon"
          variant="black"
        >
          <template v-slot:button-content>
            <i class="bx bx-bell bx-tada"></i>
            <span class="badge bg-danger rounded-pill">{{
              $t("navbar.dropdown.notification.badge")
            }}</span>
          </template>

          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">
                  {{ $t("navbar.dropdown.notification.text") }}
                </h6>
              </div>
              <div class="col-auto">
                <a href="#" class="small">{{
                  $t("navbar.dropdown.notification.subtext")
                }}</a>
              </div>
            </div>
          </div>
          <simplebar style="max-height: 230px">
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="media">
                <div class="avatar-xs me-3">
                  <span
                    class="avatar-title bg-primary rounded-circle font-size-16"
                  >
                    <i class="bx bx-cart"></i>
                  </span>
                </div>
                <div class="media-body">
                  <h6 class="mt-0 mb-1">
                    {{ $t("navbar.dropdown.notification.order.title") }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ $t("navbar.dropdown.notification.order.text") }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.order.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="media">
                <img
                  src="@/assets/images/users/avatar-3.jpg"
                  class="me-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <div class="media-body">
                  <h6 class="mt-0 mb-1">
                    {{ $t("navbar.dropdown.notification.james.title") }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ $t("navbar.dropdown.notification.james.text") }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.james.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="media">
                <div class="avatar-xs me-3">
                  <span
                    class="avatar-title bg-success rounded-circle font-size-16"
                  >
                    <i class="bx bx-badge-check"></i>
                  </span>
                </div>
                <div class="media-body">
                  <h6 class="mt-0 mb-1">
                    {{ $t("navbar.dropdown.notification.item.title") }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ $t("navbar.dropdown.notification.item.text") }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.item.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="media">
                <img
                  src="@/assets/images/users/avatar-4.jpg"
                  class="me-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <div class="media-body">
                  <h6 class="mt-0 mb-1">
                    {{ $t("navbar.dropdown.notification.salena.title") }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ $t("navbar.dropdown.notification.salena.text") }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.salena.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
          </simplebar>
          <div class="p-2 border-top d-grid">
            <a
              class="btn btn-sm btn-link font-size-14 text-center"
              href="javascript:void(0)"
            >
              <i class="mdi mdi-arrow-right-circle me-1"></i>
              {{ $t("navbar.dropdown.notification.button") }}
            </a>
          </div>
        </b-dropdown> -->

        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          menu-class="dropdown-menu-end"
          @click="getRelationMedia"
        >
          <template v-slot:button-content>
            <img
              class="rounded-circle header-profile-user"
              :src="avatar"
              alt=""
              v-if="avatar"
              @click="getRelationMedia"
            />
            <img
              class="rounded-circle header-profile-user"
              src="../assets/images/avatar.png"
              alt=""
              v-if="!avatar"
              @click="getRelationMedia"
            />
            &emsp;
            <span
              @click="getRelationMedia"
              class="d-none d-xl-inline-block ms-1"
              >{{ userName }}</span
            >
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <!-- item-->

          <!-- <b-dropdown-item>
            <router-link tag="span" to="/contacts/profile">
              <i class="bx bx-user font-size-16 align-middle me-1"></i>
              账号中心
            </router-link>
          </b-dropdown-item> -->
          <div style="max-height: 310px; overflow: auto">
            <b-dropdown-item
              @click="cutAccount(item)"
              v-for="(item, index) in actOptions"
              :key="index"
            >
              {{ item.name }}
              &emsp;&emsp;
              <i
                v-if="item.checked"
                style="font-size: 18px;"
                class="el-icon-check"
              ></i>
            </b-dropdown-item>
          </div>
          <!-- <b-dropdown-item href="javascript: void(0);">
            <i class="bx bx-wallet font-size-16 align-middle me-1"></i>
            {{ $t("navbar.dropdown.henry.list.mywallet") }}
          </b-dropdown-item> -->
          <!-- <b-dropdown-item class="d-block" href="javascript: void(0);">
            <span class="badge bg-success float-end">11</span>
            <i class="bx bx-wrench font-size-16 align-middle me-1"></i>
            {{ $t("navbar.dropdown.henry.list.settings") }}
          </b-dropdown-item>
          <b-dropdown-item href="javascript: void(0);">
            <i class="bx bx-lock-open font-size-16 align-middle me-1"></i>
            {{ $t("navbar.dropdown.henry.list.lockscreen") }}
          </b-dropdown-item> -->
          <b-dropdown-divider></b-dropdown-divider>
          <a @click="logout()" class="dropdown-item text-danger">
            <i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            ></i>
            退出登录
          </a>
        </b-dropdown>
        <b-modal
          v-model="dialogVisible"
          title="切换账号"
          cancel-title="取消"
          ok-title="确定"
          @ok="handleOk"
        >
          <h5 style="text-align: center;">确认切换账号</h5>
        </b-modal>
        <!-- 主题设置 -->
        <!-- <div class="dropdown d-inline-block">
          <button
            type="button"
            class="btn header-item noti-icon right-bar-toggle toggle-right"
            @click="toggleRightSidebar"
          >
            <i class="bx bx-cog bx-spin toggle-right"></i>
          </button>
        </div> -->
      </div>
    </div>

    <div class="alert-xb" v-if="showAlert">
      <div>
        <div class="title-alert">
          <span> {{ uploadTitle }}</span>
          <span class="flex-align-center" style="font-size:18px"
            >{{ "..." + uploadedNum }}<span style="font-size:13px;">/</span
            >{{ uploadTotal }}</span
          >
          <i
            class="bx bx-collapse showExpand"
            v-if="!showExpand"
            @click="show_expand(1)"
          ></i>
          <i
            class="bx bx-expand showExpand"
            v-if="showExpand"
            @click="show_expand(0)"
          ></i>
          <i class="bx bx-x close" @click="closeAlert"></i>
        </div>
        <div v-if="!showExpand" style="max-height: 70vh; overflow: auto">
          <div
            class="upload-item-wrap"
            v-for="item in uploadList"
            :key="item.str"
          >
            <div class="upload-item">
              <span style="font-size: 20px; margin-right: 3px; width: 20px">
                <i
                  class="mdi mdi-image"
                  style="color: #34c38f"
                  v-if="item.type == 'image'"
                ></i>
                <i
                  class="mdi mdi-file-document text-primary"
                  v-if="item.type == 'document'"
                ></i>
                <i
                  class="mdi mdi-folder text-warning"
                  v-if="item.type == 'dir'"
                ></i>
                <i
                  class="mdi mdi-play-circle-outline text-danger"
                  v-if="item.type == 'video'"
                ></i>
                <i
                  class="mdi mdi-music text-info"
                  v-if="item.type == 'audio'"
                ></i> </span
              ><span class="upload-item-title">{{ item.name }}</span>
            </div>
            <!-- <div class="upload-item">{{ showName(item.name) }}</div> -->
            <div class="showSize flex-align-center">
              <span style="width: 60px; text-align: right">{{
                item.loaded + item.unit
              }}</span
              >&nbsp;<span style="font-size:12px">/</span>&nbsp;<span
                style="width: 60px"
                >{{ item.size + item.unit }}</span
              >
            </div>
            <div>
              <t-progress
                style="width: 30px; margin-left: 10px; margin-right: 10px"
                theme="circle"
                :size="36"
                :percentage="item.rate"
                :status="`${item.status}`"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.app-breadcrumb .el-breadcrumb {
  line-height: 68px;
}

.app-breadcrumb .el-breadcrumb .el-breadcrumb__inner {
  font-weight: 700;
  text-decoration: none;
  -webkit-transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  color: #303133;
  cursor: pointer;
}

.app-breadcrumb .el-breadcrumb .el-breadcrumb__inner:hover {
  color: #556ee6 !important;
}

.app-breadcrumb .el-breadcrumb .el-breadcrumb__separator {
  font-weight: 100;
}

.app-breadcrumb .el-breadcrumb .last-breadcrumb .el-breadcrumb__inner {
  font-weight: 400;
}

.app-breadcrumb .el-breadcrumb .last-breadcrumb .el-breadcrumb__inner:hover {
  color: #303133 !important;
}

.navbar-brand-box .app-name {
  font-size: 24px;
  color: #fff;
  font-weight: 600;
}
.last-breadcrumb {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>
<style lang="scss" scoped>
.alert-xb {
  position: fixed !important;
  bottom: 100px;
  right: 20px;
  width: 400px;
  /* background-color: #e6e7e8; */
  background-color: white;
  border-radius: 0.25rem;
  /* box-shadow: 3px -3px 3px 2px #e7e7e7 inset ; */
  /* border: 1px solid transparent;
  border-color: #fafbfd; */

  /* box-shadow: 0px -0.5px 2px 0px #e5e5e5, -0.5px 0px 1px 0px #e5e5e5,
    0.5px 0px 2px 0px #e5e5e5, 0px 0.5px 2px 0px #e5e5e5; */
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.12), 0 0 1px 0 rgba(0, 0, 0, 0.08);
}
.alert-xb .upload-item-wrap {
  display: flex;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-width: 1px 0 0 0;
  height: 50px;
}
.alert-xb .upload-item {
  width: 265px;
  margin-right: 20px;
  padding-left: 10px;
  font-size: 14px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  align-items: center;
}
.alert-xb .upload-item-title {
  width: 240px;
  margin-right: 20px;
  font-size: 14px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.alert-xb .title-alert {
  display: flex !important;
  // align-items: center !important;
  height: 50px !important;
  line-height: 50px !important;
  padding-left: 10px !important;
  font-size: 18px !important;
  position: relative !important;
  text-overflow: ellipsis !important;
  overflow: hidden !important;
  white-space: nowrap !important;
}
.alert-xb .close {
  font-size: 30px;
  color: gray;
  position: absolute;
  right: 5px;
  top: 10px;
  cursor: pointer;
}
.alert-xb .showExpand {
  font-size: 20px;
  color: gray;
  position: absolute;
  right: 40px;
  top: 16px;
  cursor: pointer;
}

.alert-xb .showSize {
  width: 180px;
  font-size: 14px;
  color: gray;
  cursor: pointer;
  margin-right: 0px;
}
</style>
